import isObject from "../struct-events/is-object.js";
import Tracker from "../prop-trackers/tracker.js";
import SinglePropTracker from "../prop-trackers/single-prop-tracker.js";
import DeepChangeTracker from "./deep-change-tracker.js";
import ValueTracker from "../prop-trackers/value-tracker.js";

class SinglePropDeepTracker extends Tracker {
    constructor(strEvtCtx, userdata) {
        super();

        this._strEvtCtx = strEvtCtx;

        this._propTracker = new SinglePropTracker();
        this._deepTracker = new DeepChangeTracker(strEvtCtx);
        this._valueTracker = new ValueTracker(userdata);

        const needsUpdate = () => this.protected_needsUpdate();
        this._propTracker.listenNeedsUpdate(needsUpdate);
        this._deepTracker.listenNeedsUpdate(needsUpdate);
    }

    track(object, events, key) {
        this._propTracker.track(object, events, key);
    }

    protected_startUpdate() {
        if (this._propTracker.needsUpdate) {
            this._propTracker.update(({ prop: { newExists, newValue } }) => {
                if (newExists) {
                    this._valueTracker.setValue(newValue);
                } else {
                    this._valueTracker.deleteValue();
                }

                if (isObject(newValue)) {
                    this._deepTracker.track(newValue, this._strEvtCtx.getEvents(newValue));
                } else {
                    this._deepTracker.track();
                }
            });
        }

        if (this._deepTracker.needsUpdate) {
            this._deepTracker.update();
        }

        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._valueTracker.finishUpdate();
    }
}

export default SinglePropDeepTracker;
